<a class="sn-skip-link" href="#sn-main" (click)="skipToMain($event)">Skip to main content</a>
<app-env-bar
  [showDetailsLink]="!!currentUser()?.can('open-environment-info', 'navigation')"
  [impersonatedName]="impersonatedName"
  (revertImpersonation)="revertImpersonation()"></app-env-bar>
<div class="app-top-chrome">

  <div #appAlertStack class="app-alert-stack">
    @if (currentUser() && sessionExpiryWarning()) {
    <div class="app-top-alert alert alert-warning text-center"
      role="alert">
      {{ (sessionExpiryWarning().reason === 'absolute_timeout'
        ? 'AuthSecurity.absolute_timeout_warning'
        : 'AuthSecurity.idle_timeout_warning')
        | translate:{time: formatSessionRemaining(sessionExpiryWarning().remainingSeconds)} }}
    </div>
    }

    @if (currentUser() && passwordExpiryWarning()) {
    <div class="app-top-alert alert alert-warning text-center"
      role="alert">
      {{ 'AuthSecurity.password_expiry_warning' | translate:{date: (passwordExpiryWarning().expires_at | date:'medium')} }}
      <button class="btn btn-sm btn-primary ms-2" type="button" (click)="openPasswordSettings()">
        {{ 'AuthSecurity.change_password' | translate }}
      </button>
    </div>
    }

    @if (currentUser() && mfaAdvisory()) {
    <div class="app-top-alert alert alert-warning text-center"
      role="alert">
      @if (mfaAdvisoryHasDeadline) {
        {{ 'AuthSecurity.mfa_advisory' | translate:{days: mfaAdvisory().daysRemaining} }}
      } @else {{{ 'AuthSecurity.mfa_advisory_now' | translate }}}
      <button class="btn btn-sm btn-primary ms-2" type="button" (click)="openSecurity()">
        {{ 'AuthSecurity.setup_mfa' | translate }}
      </button>
      @if (!mfaAdvisory().dismissible) {
      <button class="btn btn-sm btn-outline-secondary ms-2"
        type="button" (click)="logout()">{{ 'AuthSecurity.logout' | translate }}</button>
      }
      @if (mfaAdvisory().dismissible) {
      <button class="btn-close" type="button"
        aria-label="Dismiss" (click)="dismissMfaAdvisory()"></button>
      }
    </div>
    }
  </div>

  <app-nav-header></app-nav-header>
</div>

<app-nav-sidebar></app-nav-sidebar>

<main id="sn-main" class="sn-app-main" tabindex="-1">
  <router-outlet></router-outlet>
</main>

<app-nav-command-palette></app-nav-command-palette>

<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="footer-menu">
          <div>
            <ul>
              <li>
                <a href="https://snoball.events" target="_blank" class="copyright">
                  &copy; Snöball
                </a>
              </li>
              <li>
                <a href="https://snoball.events/book-demo3/" target="_blank">
                  Get in Touch
                </a>
              </li>
              <li>
                <a href="https://i.snoball.it/b/privacy" target="_blank">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
